import React from "react";

const Footer = () => {
	var d = new Date();
	return (
		<div className="footer out-footer">
			<div className="copyright">
				<p>Copyright © All Rights Reserved{" "}
					{/* <a href="http://dexignzone.com/" target="_blank"  rel="noreferrer">
						DexignZone
					</a>{" "} */}
					2015
				</p>
			</div>
		</div>
	);
};

export default Footer;
